import { combineReducers } from 'redux';

import authReducer from './authentication/reducers';
import utilitiesReducer from './utilities/reducers';

import roleReducer from './userManagement/roles/reducers';
import userReducer from './userManagement/users/reducers';
import departmentReducer from './userManagement/departments/reducers';
import positionReducer from './userManagement/positions/reducers';

import dayScheduleReducer from './userAttendance/daySchedules/reducers';

import specialDaysReducer from './userAttendance/specialDays/reducers';
import leaveReducer from './userAttendance/leaves/reducers';
import attendanceCategoryReducer from './userAttendance/attendanceCategories/reducers';
import monthDeclarationsReducer from './userAttendance/monthdeclarations/reducers';
import userAttendanceReducer from './userAttendance/userAttendances/reducers';
import earlyLeaveReducer from './userAttendance/earlyLeaves/reducers';
import sandwichReducer from './userAttendance/sandwiches/reducers';
import rosterReducer from './userAttendance/rosters/reducers';
import usersForOthersReducer from './userManagement/usersForOthers/reducers';
import UserShiftEmployeesReducer from './userAttendance/shiftEmployees/reducers';

import yearlyReservedLeaveReducer from './userAttendance/yearlyReservedLeaves/reducers';

import monthlyAttendanceReducer from './userAttendance/monthlyAttendances/reducers';
import userMonthlyAttendanceReducer from './userAttendance/userMonthlyAttendances/reducers';

import criteriaReducer from './kpi/criterias/reducers';
import kpiTeacherReducer from './kpi/kpi-users/reducers';

import logReducer from './userManagement/logs/reducers';
import scheduleReducer from './schedule/reducers';

import studentsReducer from './students/students/reducers';
import cardReducer from './students/card/reducers';
import studentAttendanceReducer from './students/attendance/reducers';
import subjectiveAttendanceReducer from './academic/subjectiveAttendance/reducers';
import studentResultsReducer from './students/results/reducers';
import quickStudentReducer from './students/search/reducers';

import allStudentReducer from './students/all-students/reducers';

import routineReducer from './academic/routines/reducers'
import coordinationReducer from './academic/coordinaton/reducers'
import coordinationMockReducer from './academic/coordinaton/mock/reducers'
import NoteReducer from './academic/notes/reducers'
import NoticeReducer from './academic/notices/reducers'
import attendanceReducer from './academic/attendance/reducers'
import paymentsReducer from './academic/payments/reducers'
import transactionsReducer from './academic/transactions/reducers'
import calendersReducer from './academic/calender/reducers'

import resultMockReducer from './academic/result/mock/reducers'
import resultQuarterReducer from './academic/result/quarter/reducers'
import resultHalfYearlyReducer from './academic/result/halfYearly/reducers'
import resultFinalReducer from './academic/result/final/reducers'

import reportsQuarterReducer from './academic/reports/quarter/reducers'
import reportsMockReducer from './academic/reports/mock/reducers'
import reportsFinalReducer from './academic/reports/final/reducers'
import reportsHalfYearlyReportReducer from './academic/reports/halfYearly/reducers'

import performanceQuarterReducer from './academic/performance/reducers'

import classRoomReducer from './academic/setup/classRooms/reducers'
import subjectReducer from './academic/setup/subjects/reducers'
import periodReducer from './academic/setup/periods/reducers'
import sessionReducer from './academic/setup/sessions/reducers'
import sectionsReducer from './academic/setup/sections/reducers'
import classesReducer from './academic/setup/classes/reducers'
import paymentTypeReducer from './academic/setup/paymentTypes/reducers'
import dashboardReducer from './dashboard/reducers'
import invoiceReducer from './invoice/reducers'
import messageReducer from './message/reducers'
import studentsResultAccessReducer from './student-access/reducers'

import careerReducer from './admin/reducers'
import blogReducer from './blogs/reducers'
import resultReducer from './results/reducers'
import slideReducer from './slides/reducers'
import galleryReducer from './galleries/reducers'
import MarksInputPermissionReducer from './marksInputPermission/reducers'
import UserPermissionReducer from './marksInputPermission/allowUserMarksInput/reducers'
import ProductCategoryReducer from './ITComponent/productCategories/reducers'
import ITComponentReducer from './ITComponent/components/reducers'

import AttendancePermissionReducer from './attendanceInputPermission/reducers'
import AllowAttendanceReducer from './attendanceInputPermission/allowUserAttendanceInput/reducers'

import ChangeLayoutMode from './themeLayout/reducers';

import emailReducer from './emails/reducers'
import forwardReducer from './forwards/reducers'

import admissionSlideReducer from './admissionSlides/reducers'
import resultSlideReducer from './resultSlides/reducers'
import substituteReducer from './academic/substituteRoutines/reducers'
import preRoutineReducer from './academic/preRoutines/reducers'
import salaryDeclarationReducer from './employee-salary/salary-declaration/reducers'
import salaryMonthDeclarationReducer from './employee-salary/salary-month-declaration/reducers'
import salaryIncrementMonthDeclarationReducer from './employee-salary/salary-increment-month-declaration/reducers'
import monthlySalaryReducer from './employee-salary/month-salary/reducers'
import providentFundEmployeeReducer from './employee-salary/provident-fund-employees/reducers'
import teacherEmailReducer from './domain-emails/reducers'
import NotificationReducer from './notifications/reducers'

import AppointedTeacherReducer from './appointment/appointedTeachers/reducers'
import GetAppointmentsReducer from './appointment/getAppointments/reducers'

import EmailServerInvoiceReducer from './email-server-invoice/reducers'
import ChangedPermissionReducer from './userManagement/rolesPermissions/reducers'

import ResultPublicationReducer from './result-publication/reducers'
import HolidayDeclarationReducer from './holiday-sms/reducers'

import ExamCalendarReducer from './exam-calendar/reducers'
import MCWScheduleReducer from './mcw-schedule/reducers'
import CTScheduleReducer from './ct-schedule/reducers'
import EmailGroupReducer from './email-group/reducers'
import TeacherEmailDraftReducer from './teacherEmailDraft/reducers'

import MainClubReducer from './clubs/main-club/reducers'
import SubClubReducer from './clubs/sub-club/reducers'
import studentMembershipClubReducer from './clubs/student-membership-club/reducers'

import academicPredictedGrade from './academic/predictedGrade/reducers'
import academicTranscript from './academic/academicTranscript/reducers'

const rootReducers = combineReducers({
    auth: authReducer,
    utilities: utilitiesReducer,

    changedPermissions: ChangedPermissionReducer,
    holidayDeclarationReducer: HolidayDeclarationReducer,
    ctScheduleReducer: CTScheduleReducer,
    mcwScheduleReducer: MCWScheduleReducer,

    examCalendarReducer: ExamCalendarReducer,

    emailGroupReducer: EmailGroupReducer,

    academicPredictedGrade: academicPredictedGrade,
    academicTranscript: academicTranscript,

    umRoles: roleReducer,
    umUsers: userReducer,
    umDepartments: departmentReducer,
    umPositions: positionReducer,

    teacherEmailDraft: TeacherEmailDraftReducer,

    salaryDeclaration: salaryDeclarationReducer,
    salaryMonthDeclarations: salaryMonthDeclarationReducer,
    incrementMonthDeclarations: salaryIncrementMonthDeclarationReducer,
    monthlySalaries: monthlySalaryReducer,

    ResultPublications: ResultPublicationReducer,

    emailServerInvoices: EmailServerInvoiceReducer,

    teacherEmails: teacherEmailReducer,

    notifications: NotificationReducer,

    mainClub: MainClubReducer,
    subClub: SubClubReducer,
    studentMembershipClub: studentMembershipClubReducer,

    AppointedTeachers: AppointedTeacherReducer,
    GetAppointments: GetAppointmentsReducer,

    providentFundEmployees: providentFundEmployeeReducer,

    umPreRoutines: preRoutineReducer,

    umSubstitutes: substituteReducer,

    utShiftEmployees: UserShiftEmployeesReducer,

    utDaySchedules: dayScheduleReducer,
    utSpecialDays: specialDaysReducer,
    utLeaves: leaveReducer,
    utAttendances: userAttendanceReducer,
    utEarlyLeaves: earlyLeaveReducer,
    utSandwiches: sandwichReducer,
    utRosters: rosterReducer,
    utUsers: usersForOthersReducer,
    utYearlyReservedLeaves: yearlyReservedLeaveReducer,
    utAttendanceCategory: attendanceCategoryReducer,
    utMonthDeclaration: monthDeclarationsReducer,

    utMonthlyAttendance: monthlyAttendanceReducer,
    utUserMonthlyAttendance: userMonthlyAttendanceReducer,

    umCriterias: criteriaReducer,
    umKpiTeachers: kpiTeacherReducer,

    productCategories: ProductCategoryReducer,
    itComponents: ITComponentReducer,

    umLogs: logReducer,
    umSchedules: scheduleReducer,

    studentsCards: cardReducer,
    studentAttendance: studentAttendanceReducer,
    studentResults: studentResultsReducer,
    quickStudent: quickStudentReducer,

    allStudents: allStudentReducer,
    studentAccess: studentsResultAccessReducer,

    allCareers: careerReducer,
    blogs: blogReducer,
    results: resultReducer,
    slides: slideReducer,
    galleries: galleryReducer,
    admissionSlides: admissionSlideReducer,
    resultSlides: resultSlideReducer,

    emails: emailReducer,
    forwards: forwardReducer,

    MarksInputPermission: MarksInputPermissionReducer,
    AllowMarksInput: UserPermissionReducer,

    AttendancePermission: AttendancePermissionReducer,
    AllowAttendanceInput: AllowAttendanceReducer,

    studentsStudents: studentsReducer,
    academicRoutines: routineReducer,

    academicCoordination: coordinationReducer,
    academicCoordinationMock: coordinationMockReducer,

    academicNote: NoteReducer,
    academicNotice: NoticeReducer,

    academicSubjectiveAttendance: subjectiveAttendanceReducer,

    academicAttendance: attendanceReducer,
    academicPayments: paymentsReducer,
    academicTransactions: transactionsReducer,
    academicCalenders: calendersReducer,

    academicResultMock: resultMockReducer,
    academicResultQuarter: resultQuarterReducer,
    academicResultHalfYearly: resultHalfYearlyReducer,
    academicResultFinal: resultFinalReducer,

    academicPerformanceQuarter: performanceQuarterReducer,

    academicReportsQuarter: reportsQuarterReducer,
    academicReportsMock: reportsMockReducer,
    academicReportsFinal: reportsFinalReducer,
    academicReportsHalfYearly: reportsHalfYearlyReportReducer,

    academicClassRooms: classRoomReducer,
    academicSubjects: subjectReducer,
    academicPeriods: periodReducer,
    academicSessions: sessionReducer,
    academicClasses: classesReducer,
    academicSections: sectionsReducer,
    academicPaymentTypes: paymentTypeReducer,

    dashboardData: dashboardReducer,
    invoiceData: invoiceReducer,
    messageData: messageReducer,

    ChangeLayoutMode,
});

export default rootReducers;
